import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductVisitorFilledSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductVisitorFilledSvg = ({
  ...svgProps
}: ProductVisitorFilledSvgProps) => (
  <SvgWrapper width="18" height="18" viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 4.5C13.2149 4.50006 14 5.28504 14 6.25V16.25C14 17.215 13.2149 17.9999 12.25 18H5.75C4.785 18 4 17.215 4 16.25V6.25C4 5.285 4.785 4.5 5.75 4.5H12.25ZM6.75 13.5C6.335 13.5 6 13.835 6 14.25C6 14.665 6.335 15 6.75 15H11.25C11.6649 14.9999 12 14.665 12 14.25C12 13.835 11.6649 13.5001 11.25 13.5H6.75ZM9 7.5C7.89545 7.5 7 8.39545 7 9.5C7 10.6045 7.89545 11.5 9 11.5C10.1045 11.4999 11 10.6045 11 9.5C11 8.39549 10.1045 7.50006 9 7.5Z"
    />
    <path d="M9.53027 3.28027C9.23738 3.57317 8.76262 3.57316 8.46973 3.28027L5.18945 0H7.31055L9 1.68945L10.6895 0H12.8105L9.53027 3.28027Z" />
  </SvgWrapper>
);
